import { render } from "./JobCallsView.vue?vue&type=template&id=05f63eb1&ts=true"
import script from "./JobCallsView.vue?vue&type=script&lang=ts"
export * from "./JobCallsView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__